import { Constants } from '@pwc/pwc-deals-web-common';
import { get, cloneDeep } from 'lodash';
import { getExcelLibraryItemsByGroup } from '../../../contentLibrary/libraryItemService';

class NamedRangeLibraryItem {
  constructor(libraryItem, formatType = 'HTML') {
    this.data = JSON.parse(libraryItem.data);
    this.type = libraryItem.type;
    this.libraryItemType = Constants.LIBRARY_ITEM_TYPES.EXCEL_NAMED_RANGE.value;
    this.formatType = formatType;
    this.service = getExcelLibraryItemsByGroup;
    this.libraryItem = libraryItem;
  }

  get sharePointUrl() {
    return this.data.sharePointUrl;
  }

  extractSourceName() {
    const source = {
      source: `${this.data.name || this.data.Name}`,
    };
    return source;
  }

  getRequestPayload() {
    let cellRange = get(this.data, 'CellRange');
    const uniqueId = get(this.data, 'UniqueId') || get(this.data, 'uniqueId');
    const workSheetName =
      get(this.data, 'WorksheetName') || get(this.data, 'worksheetName');
    const namedRange = get(this.data, 'Name') || get(this.data, 'name');

    if (!cellRange && namedRange) {
      const cells = namedRange.replace('NR_', '').split('_');
      cellRange = `'${workSheetName}'!${cells[0]}:${cells[1]}`;
    }

    const data = {
      id: this.libraryItem.id,
      name: this.libraryItem.name,
      type: this.libraryItem.type,
      data: {
        formatType: 'HTML',
        namedRange,
        workSheetName,
        uniqueId,
        cellRange,
      },
    };

    const svgData = {
      id: this.libraryItem.id,
      name: this.libraryItem.name,
      type: this.libraryItem.type,
      data: {
        formatType: 'SVG',
        namedRange,
        workSheetName,
        uniqueId,
        cellRange,
      },
    };

    return {
      ...cloneDeep(this.data),
      excelLibraryItems: [data, svgData],
    };
  }
}

export default NamedRangeLibraryItem;
